






import { types } from '@/main/store/external/types';

import { DmsBaseComponent } from '#components/dms/common/base';

import ExternalModule from './components/ExternalModule.vue';

export default DmsBaseComponent.extend({
	name: 'mpov',
	components: {
		ExternalModule,
	},
	computed: {
		url() {
			return this.$store.getters[`external/${types.getters.EXTERNAL_URL}`];
		},
	},
});
